module.exports = __webpack_public_path__ + "9e8ee6b82648db21a41d458fca95f868.png";